import React, { useEffect, useRef, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { TextField } from "@culturehq/components";

import { Trans } from "app/utils";

interface TextAreaInputProps {
  activeElement: ElementState;
  preview: Preview;
}

const TextAreaInput: React.FC<TextAreaInputProps> = ({ activeElement, preview }) => {
  const { source: { text } } = activeElement;
  const timeoutRef = useRef<any>(null);
  const [inputText, setInputText] = useState<string>(text);

  useEffect(
    () => {
      setInputText(text);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [activeElement.source.id]
  );

  const applyModifications = async (value: string) => {
    await preview.applyModifications({
      [`${activeElement.source.id}.text`]: value
    });
  };

  const handleTextChange = async (value: string | null) => {
    if (value || value === "") {
      setInputText(value);
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => applyModifications(value), 300);
    }
  };

  return (
    <TextField className="chq-ffd-border" name="text" onChange={handleTextChange} required rows={3} value={inputText}>
      <Trans>Text</Trans>
    </TextField>
  );
};

export default TextAreaInput;
